import React, {PureComponent} from "react";
import { bool, arrayOf, shape, string } from "prop-types";
import Select from "react-select";
import window from "global/window";

class AutoCompleteSearch extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            selectValue: ""
        };

        this.updateValue = this.updateValue.bind(this);
    }

    updateValue(newValue) {
        this.setState({
            selectValue: newValue
        }, (()=>{
                if(this.props.redirectToValue){
                    window.location= newValue;
                }
            }));
    }

    render(){
        let {options, placeholder} = this.props;

        return(
            <div className="AutoCompleteSearch">
                <Select
                    options={options}
                    simpleValue
                    clearable
                    name="search"
                    placeholder={placeholder}
                    value={this.state.selectValue}
                    onChange={this.updateValue}
                    searchable
                    labelKey="name"
                    valueKey="value"
                />
            </div>
        );
    }
}
AutoCompleteSearch.defaultProps = {
    placeholder: "Search..."
};

AutoCompleteSearch.propTypes = {
    options: arrayOf(
        shape({
            name: string,
            value: string
        })
    ),
    redirectToValue: bool,
    placeholder: string
};

export default AutoCompleteSearch;